var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.isMaintenance)?[_c('router-view'),_c('RedirectModal',{ref:"redirectModal",attrs:{"path":_vm.redirectModalPath,"redirectedCountry":_vm.redirectedCountry},on:{"modal-closed":function($event){_vm.redirectModalState = false}}})]:[_c('Maintenance')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }